module.exports = __webpack_public_path__ + "img/tiyu.c438d3fc.png";